/**
 * 布局测量值在临界附近常会来回跳 1～2px；若每次都 setState，
 * 再叠加显隐滚动条/改变表格高度，会触发 Maximum update depth。
 */
export function stabilizeLayoutMetric(
  previous: number,
  next: number,
  tolerance = 2,
): number {
  if (!Number.isFinite(next)) {
    return previous;
  }
  return Math.abs(previous - next) <= tolerance ? previous : next;
}

/**
 * 横向溢出判定带迟滞：已溢出时需明显收窄才关闭，未溢出时需明显超出才打开，
 * 避免滚动条自身占位导致 clientWidth 抖动。
 */
export function stabilizeHorizontalOverflow(
  previous: boolean,
  scrollWidth: number,
  clientWidth: number,
): boolean {
  const overflowBy = scrollWidth - clientWidth;
  if (!Number.isFinite(overflowBy)) {
    return previous;
  }
  if (previous) {
    return overflowBy > 1;
  }
  return overflowBy > 8;
}
